import gql from 'graphql-tag';

export default gql`
  mutation disableWorkflowsByChannelAndType(
    $channelId: UUID!
    $type: WorkflowType!
  ) {
    disableWorkflowsByChannelAndType(channelId: $channelId, type: $type)
  }
`;
